var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 96,
    viewBox: "0 0 88 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#listings_svg__filter0_d_511_5920)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#listings_svg__paint0_linear_511_5920)",
    fillOpacity: 0.7,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#listings_svg__paint1_linear_511_5920)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.829 23.2459C42.8978 22.8952 43.0862 22.5793 43.362 22.3521C43.6377 22.1249 43.9837 22.0004 44.3409 22H51.656C52.0129 22.0003 52.3587 22.1245 52.6344 22.3513C52.9101 22.578 53.0986 22.8934 53.168 23.2437L53.3708 24.2603L53.373 24.2692L53.9791 27.2241C54.799 27.599 55.5638 28.0467 56.2757 28.5473L59.2952 27.5395L59.326 27.5285L60.3399 27.2131C60.6733 27.1092 61.032 27.1216 61.3575 27.2482C61.683 27.3747 61.956 27.608 62.1317 27.91L62.6563 28.8097L65.2614 33.1738L65.7904 34.0801C65.9709 34.3903 66.0378 34.7538 65.9795 35.1079C65.9211 35.4621 65.7413 35.7849 65.4708 36.0207L64.684 36.7087L62.4249 38.6295C62.491 39.0507 62.5439 39.5204 62.5439 40.0011C62.5439 40.4818 62.4888 40.9515 62.4249 41.3727L64.695 43.3067L65.4708 43.9815C65.7413 44.2173 65.9211 44.5401 65.9795 44.8943C66.0378 45.2485 65.9709 45.6119 65.7904 45.9221L65.2526 46.8439L62.6563 51.1881L62.1317 52.0923C61.9559 52.3946 61.6826 52.6283 61.3566 52.7549C61.0306 52.8815 60.6714 52.8935 60.3377 52.7891L59.2929 52.4627L56.2757 51.4527C55.5616 51.9533 54.799 52.401 53.9791 52.7759L53.373 55.7308V55.7397L53.168 56.7585C53.0982 57.1084 52.9094 57.4232 52.6338 57.6496C52.3581 57.8759 52.0126 57.9998 51.656 58H44.3409C43.9837 57.9996 43.6377 57.8751 43.362 57.6479C43.0862 57.4207 42.8978 57.1048 42.829 56.7541L42.6284 55.733L42.0201 52.7781C41.2149 52.4076 40.4454 51.9639 39.7213 51.4527L36.6753 52.4715L35.6593 52.7891C35.3248 52.8937 34.9647 52.8813 34.6382 52.7538C34.3117 52.6264 34.0383 52.3915 33.863 52.0878L33.3429 51.1881L30.7355 46.8262L30.2088 45.9199C30.0288 45.6099 29.9623 45.2469 30.0206 44.8933C30.0789 44.5396 30.2584 44.2172 30.5283 43.9815L31.3152 43.2935L33.5721 41.3727C33.4981 40.9192 33.4583 40.4607 33.4531 40.0011C33.4531 39.5226 33.5082 39.0529 33.5721 38.6317L31.2997 36.6955L30.5283 36.0207C30.2584 35.785 30.0789 35.4626 30.0206 35.1089C29.9623 34.7553 30.0288 34.3923 30.2088 34.0823L30.7465 33.1561L33.3429 28.8119L33.8652 27.9144C34.0406 27.6125 34.313 27.3791 34.638 27.2521C34.9631 27.1251 35.3215 27.1122 35.6549 27.2153L36.6709 27.5307L36.704 27.5417L39.7235 28.5495C40.4354 28.0489 41.2002 27.6012 42.0201 27.2263L42.6262 24.2692L42.829 23.2481V23.2459ZM45.6082 25.0873L44.8765 28.6421C44.8241 28.8956 44.7089 29.1319 44.5413 29.3292C44.3738 29.5265 44.1594 29.6785 43.9177 29.7711C42.8471 30.189 41.8455 30.7659 40.9467 31.4824C40.7458 31.64 40.509 31.7453 40.2574 31.7888C40.0058 31.8323 39.7474 31.8126 39.5053 31.7316L35.9128 30.5275L33.5192 34.53L36.2389 36.8455C36.4409 37.0176 36.5951 37.2389 36.6866 37.4881C36.7781 37.7372 36.8038 38.0058 36.7613 38.2678C36.7393 38.4178 36.715 38.5545 36.693 38.6846C36.6048 39.2028 36.5387 39.5821 36.5387 39.9989C36.5387 40.4179 36.6048 40.7972 36.693 41.3132L36.7613 41.7322C36.8038 41.9942 36.7781 42.2628 36.6866 42.5119C36.5951 42.7611 36.4409 42.9824 36.2389 43.1545L33.5192 45.47L35.9128 49.4681L39.5053 48.2662C39.7474 48.1852 40.0058 48.1655 40.2574 48.209C40.509 48.2525 40.7458 48.3578 40.9467 48.5154C41.857 49.2299 42.8444 49.8165 43.9177 50.2266C44.1594 50.3193 44.3738 50.4713 44.5413 50.6686C44.7089 50.8659 44.8241 51.1022 44.8765 51.3557L45.6082 54.9105H50.3909L51.1183 51.3579C51.1707 51.1035 51.2865 50.8664 51.4548 50.6687C51.6232 50.4709 51.8387 50.3189 52.0814 50.2266C53.1513 49.8086 54.1521 49.2317 55.0502 48.5154C55.2511 48.3578 55.488 48.2525 55.7395 48.209C55.9911 48.1655 56.2495 48.1852 56.4916 48.2662L60.0886 49.4703L62.4778 45.4678L59.758 43.1523C59.5553 42.9798 59.4007 42.7577 59.3092 42.5077C59.2177 42.2577 59.1923 41.9883 59.2356 41.7256L59.2974 41.3683C59.3899 40.8281 59.4583 40.4289 59.4583 39.9989C59.4583 39.5689 59.3899 39.1719 59.2974 38.6317L59.2379 38.2722C59.1939 38.0094 59.2187 37.7396 59.3098 37.4892C59.401 37.2388 59.5554 37.0162 59.758 36.8432L62.4778 34.5278L60.0886 30.5275L56.4916 31.7316C56.2495 31.8126 55.9911 31.8323 55.7395 31.7888C55.488 31.7453 55.2511 31.64 55.0502 31.4824C54.1521 30.766 53.1513 30.1891 52.0814 29.7711C51.8391 29.6786 51.624 29.5264 51.4561 29.3287C51.2881 29.131 51.1727 28.8941 51.1205 28.6399L50.3931 25.0895H45.6104L45.6082 25.0873ZM47.9996 36.841C46.254 36.841 44.839 38.2568 44.839 39.9989C44.839 40.8373 45.1719 41.6413 45.7644 42.2342C46.3569 42.827 47.1605 43.1601 47.9985 43.1601C48.8364 43.1601 49.64 42.827 50.2325 42.2342C50.8251 41.6413 51.1579 40.8373 51.1579 39.9989C51.1579 38.2568 49.743 36.841 47.9996 36.841ZM41.7534 39.9989C41.7534 38.3417 42.4114 36.7524 43.5825 35.5806C44.7537 34.4088 46.3422 33.7504 47.9985 33.7504C49.6548 33.7504 51.2432 34.4088 52.4144 35.5806C53.5856 36.7524 54.2436 38.3417 54.2436 39.9989C54.2436 41.6561 53.5856 43.2454 52.4144 44.4172C51.2432 45.589 49.6548 46.2473 47.9985 46.2473C46.3422 46.2473 44.7537 45.589 43.5825 44.4172C42.4114 43.2454 41.7534 41.6561 41.7534 39.9989Z",
    fill: "url(#listings_svg__paint2_linear_511_5920)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "listings_svg__paint0_linear_511_5920",
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEF2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "listings_svg__paint1_linear_511_5920",
    x1: 48,
    y1: 0,
    x2: 28.5,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "listings_svg__paint2_linear_511_5920",
    x1: 48,
    y1: 22,
    x2: 56.25,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DDE4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1863F4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "listings_svg__filter0_d_511_5920",
    x: 0,
    y: 0,
    width: 88,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.89276 0 0 0 0 0.959249 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_511_5920"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_511_5920",
    result: "shape"
  })))));
}

export default SvgListings;